import { gql } from "@apollo/client";

// Places an outbound Messenger call. Agent's browser builds the SDP
// offer first, we send it to Meta, Meta returns an SDP answer and a
// new call_id. The active call widget renders the same as inbound.
const INITIATE_MESSENGER_CALL = gql`
  mutation initiateMessengerCall($inboxId: ID!, $sdpOffer: String!) {
    initiateMessengerCall(inboxId: $inboxId, sdpOffer: $sdpOffer) {
      success
      error
      sdpResponse
      sdpRenegotiation
      call {
        id
        callId
        pageId
        psid
        inboxId
        agentId
        direction
        status
        customerName
        customerPicture
      }
    }
  }
`;

export default INITIATE_MESSENGER_CALL;
